export default "__VITE_ASSET__BL0N8kvw__"